import { OrganizationOrigin } from '@masar/common/enums';
import { isOrigin } from '@masar/common/utils/is-origin.util';

export const isNotOrigin = (
    organizationOrigins: OrganizationOrigin[]
): boolean => !isOrigin(organizationOrigins);
